import 'globals';

(function ($, window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        if ($.prototype.slick) {
            $('.slider__items').slick();
            $('.slider__items').on('beforeChange', function () {
                if (window.lazyLoadObject instanceof window.LazyLoad) {
                    window.lazyLoadObject.update();
                }
            });
            $('.imageGallery__slider--items').on('init', function () {
                if (window.lazyLoadObject instanceof window.LazyLoad) {
                    window.lazyLoadObject.update();
                }
            });
        }
        if ($('.imageGallery__slider--items').length) {
            $('.imageGallery__slider--items').slick();
            $('.imageGallery__slider--items .slick-slide').addClass('col-md-4');
        }

        if ($('.product-image-slider').length) {
            $('.product-image-slider').slick({
                autoplay: false,
                dots: true,
                arrows: false,
                customPaging: function (slider, i) {
                    var thumb = $(slider.$slides[i]).find('.product-image').data('thumb');
                    return '<a><img src="' + thumb + '"></a>';
                }
            });
        }

    });
})(jQuery, window, document, window.PageLoadedQueue);
